/**
 * Ticket Card Component
 * Displays ticket entity information from MCP tool results
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import type { TicketEntity } from '@/api/types/mcp.types';
import './EntityCard.css';

interface TicketCardProps {
  ticket: TicketEntity;
  compact?: boolean;
}

export const TicketCard: React.FC<TicketCardProps> = ({
  ticket,
  compact = false,
}) => {
  const statusColors: Record<string, string> = {
    open: 'green',
    in_progress: 'blue',
    pending: 'orange',
    closed: 'default',
    resolved: 'purple',
  };

  const priorityColors: Record<string, string> = {
    high: 'red',
    medium: 'orange',
    low: 'default',
  };

  return (
    <div className={`ticket-card entity-card ${compact ? 'compact' : ''}`}>
      <div className="entity-card-header">
        <h4 className="entity-card-title">{ticket.title}</h4>
        <div className="ticket-tags">
          {ticket.status && (
            <Tag color={statusColors[ticket.status] || 'default'}>
              {ticket.status}
            </Tag>
          )}
          {ticket.priority && (
            <Tag color={priorityColors[ticket.priority] || 'default'}>
              {ticket.priority}
            </Tag>
          )}
        </div>
      </div>

      {!compact && (
        <div className="entity-card-body">
          <div className="entity-card-field">
            <span className="field-label">ID:</span>
            <span className="field-value">{ticket.id.substring(0, 8)}...</span>
          </div>
        </div>
      )}

      <div className="entity-card-footer">
        <Link to={`/apps/tickets/${ticket.id}`} className="entity-card-link">
          View Ticket →
        </Link>
      </div>
    </div>
  );
};
